import { render, staticRenderFns } from "./MobileCard.vue?vue&type=template&id=4a022ddc&scoped=true"
import script from "./MobileCard.vue?vue&type=script&lang=ts"
export * from "./MobileCard.vue?vue&type=script&lang=ts"
import style0 from "./MobileCard.vue?vue&type=style&index=0&id=4a022ddc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a022ddc",
  null
  
)

export default component.exports